import some from 'lodash/some';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import every from 'lodash/every';
import differenceBy from 'lodash/differenceBy';
import forEach from 'lodash/forEach';
import findIndex from 'lodash/findIndex';
import React from 'react';
import arrayTreeFilter from 'array-tree-filter';
import classnames from 'classnames';
import CSSMotion from 'rc-motion';
import Checkbox from '../checkbox';
import List from '../virtual-list';
import MenuItem from './MenuItem';
import { getElementStyle, isIncludeArray } from './utils';
const DEFAULT_MENU_GAP = 4; // 菜单之间默认4px的间距
class Menus extends React.Component {
    constructor(props) {
        super(props);
        this.menus = {};
        this.vMenus = {};
        this.menuItems = {};
        this.saveMenuWrap = menuWrap => {
            this.menuWrap = menuWrap;
        };
        this.saveMenus = menuIndex => menus => {
            this.menus[menuIndex] = menus;
        };
        this.saveVMenus = menuIndex => menus => {
            this.vMenus[menuIndex] = menus;
        };
        this.saveMenuItems = index => node => {
            this.menuItems[index] = node;
        };
        this.handleMenuScroll = menuIndex => e => {
            var _a, _b, _c, _d;
            const { menuScrollOpen } = this.state;
            if (menuScrollOpen) {
                // 当前menu滚动时，取消当前选中项高亮，隐藏子级
                const activeValue = this.props.activeValue.slice(0, menuIndex);
                if (!isEqual(activeValue, this.props.activeValue)) {
                    (_b = (_a = this.props).onActiveValueSet) === null || _b === void 0 ? void 0 : _b.call(_a, activeValue);
                }
                (_d = (_c = this.props).onDropdownMenuScroll) === null || _d === void 0 ? void 0 : _d.call(_c, e, menuIndex);
            }
        };
        this.onShowActive = () => {
            this.scrollActiveItemToView();
            window.setTimeout(() => {
                this.setMenuPosition();
                window.setTimeout(() => {
                    this.handleMenuScrollChange(true);
                }, 0);
            }, 0);
        };
        this.onShowEnd = () => {
            this.handleMenuScrollChange(false);
        };
        this.state = {
            // 默认关闭对menu scroll事件的监听，待scrollActiveItemToView完成后开启
            menuScrollOpen: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.activeValue, this.props.activeValue)
            || prevProps.options !== this.props.options) {
            this.setMenuPosition();
        }
    }
    isStatusOption(statusValue = [], option, menuIndex) {
        return statusValue[menuIndex] === option[this.getFieldName('value')];
    }
    isActiveOption(value, optionValue) {
        let active = true;
        forEach(optionValue, (val, index) => {
            if (val !== value[index]) {
                active = false;
                return false;
            }
        });
        return active;
    }
    getFieldName(name) {
        const { fieldNames, defaultFieldNames } = this.props;
        // 防止只设置单个属性的名字
        return fieldNames[name] || defaultFieldNames[name];
    }
    getOption(option, menuIndex) {
        const { prefixCls, mode, keyword, value, activeValue, hoveredValue, expandTrigger, expandIcon, loadingIcon, titlePlacement } = this.props;
        const isMulti = mode === 'multiple';
        const optionValue = (() => {
            const value = option[this.getFieldName('value')];
            return React.isValidElement(value) ? menuIndex : value;
        })();
        const optionKey = [...activeValue.slice(0, menuIndex), optionValue];
        const hasChildren = option[this.getFieldName('children')]
            && option[this.getFieldName('children')].length > 0;
        const hasLeaf = hasChildren || option.isLeaf === false;
        const onSelect = this.props.onSelect.bind(this, option, menuIndex);
        const onMultiSelect = this.props.onMultiSelect.bind(this, option, menuIndex, optionKey);
        const onItemDoubleClick = this.props.onItemDoubleClick.bind(this, option, menuIndex);
        const handleClick = e => {
            isMulti && !hasLeaf ? undefined : onSelect(e);
        };
        const handleMultiClick = e => {
            if (activeValue[menuIndex] === optionValue) {
                e.stopPropagation();
            }
        };
        let expandProps = {
            onClick: handleClick,
            onDoubleClick: onItemDoubleClick
        };
        let menuItemCls = `${prefixCls}-menu-item`;
        if (isMulti) {
            menuItemCls += ` ${prefixCls}-menu-item-multi`;
        }
        let expandIconNode = null;
        if (hasLeaf) {
            menuItemCls += ` ${prefixCls}-menu-item-expand`;
            if (!option.loading) {
                expandIconNode = (<span className={`${prefixCls}-menu-item-expand-icon`}>
                        {expandIcon}
                    </span>);
            }
        }
        if (expandTrigger === 'hover') {
            expandProps = {
                onMouseEnter: this.delayOnEvent.bind(this, onSelect),
                onMouseLeave: this.delayOnEvent.bind(this),
                onClick: handleClick
            };
        }
        if (this.isStatusOption(hoveredValue, option, menuIndex) && hasLeaf) {
            menuItemCls += ` ${prefixCls}-menu-item-hovered`;
        }
        if (this.isStatusOption(activeValue, option, menuIndex)) {
            expandProps.ref = this.saveMenuItems(menuIndex);
        }
        if (!isMulti && this.isActiveOption(value, optionKey)) {
            menuItemCls += ` ${prefixCls}-menu-item-active`;
        }
        if (option.disabled) {
            menuItemCls += ` ${prefixCls}-menu-item-disabled`;
        }
        let loadingIconNode = null;
        if (option.loading) {
            menuItemCls += ` ${prefixCls}-menu-item-loading`;
            loadingIconNode = loadingIcon || null;
        }
        const { checked, indeterminate } = (() => {
            if (!isMulti) {
                return {};
            }
            let checked;
            let indeterminate;
            if (keyword) {
                checked = isIncludeArray(value, optionValue);
            }
            else if (hasLeaf) {
                const children = option[this.getFieldName('children')];
                const getEnableValues = this.props.getEnableValues.bind(this);
                const getTotalValues = this.props.getTotalValues.bind(this);
                const enableValues = getEnableValues(children);
                const totalValues = getTotalValues(children);
                const disabledValues = differenceBy(totalValues, enableValues, JSON.stringify);
                const selectedValue = map(value, valueItem => valueItem.slice(menuIndex + 1));
                const disabledSelectedValues = [];
                forEach(disabledValues, valueItem => {
                    if (isIncludeArray(selectedValue, valueItem)) {
                        disabledSelectedValues.push(valueItem);
                    }
                });
                const childrenValue = [...getEnableValues(children), ...disabledSelectedValues];
                const includeCallback = (valueItem) => isIncludeArray(value, [...optionKey, ...valueItem]);
                checked = !isEmpty(childrenValue) && every(childrenValue, includeCallback);
                indeterminate = !checked && some(childrenValue, includeCallback);
            }
            else {
                checked = isIncludeArray(value, optionKey);
            }
            return {
                checked: checked,
                indeterminate: indeterminate
            };
        })();
        const label = option[this.getFieldName('label')];
        const labelContent = (<span className={`${prefixCls}-menu-item-label`}>
                {label}
            </span>);
        const menuItemProps = {
            key: optionKey,
            option,
            label,
            menuItemCls,
            expandProps,
            prefixCls,
            isMulti,
            checked,
            indeterminate,
            labelContent,
            expandIconNode,
            loadingIconNode,
            handleMultiClick,
            onMultiSelect,
            onMouseEnter: expandProps === null || expandProps === void 0 ? void 0 : expandProps.onMouseEnter,
            titlePlacement
        };
        return <><MenuItem {...menuItemProps}/></>;
    }
    getCheckAllOption(menuIndex) {
        const { mode, prefixCls, value, enableValues, totalValues, withCheckAll = true, locale } = this.props;
        const isMulti = mode === 'multiple';
        if (!(isMulti && menuIndex === 0) || !withCheckAll) {
            return null;
        }
        const disabledValues = differenceBy(totalValues, enableValues, JSON.stringify);
        const disabledSelectedValues = [];
        forEach(disabledValues, valueItem => {
            if (isIncludeArray(value, valueItem)) {
                disabledSelectedValues.push(valueItem);
            }
        });
        const childrenValue = [...enableValues, ...disabledSelectedValues];
        const checked = value.length > 0 && value.length >= childrenValue.length && childrenValue.every(valueItem => isIncludeArray(value, valueItem));
        const indeterminate = !checked && value.length > 0;
        const onMultiSelectAll = this.props.onMultiSelectAll.bind(this);
        return (<li className={`${prefixCls}-menu-item ${prefixCls}-menu-item-multi ${prefixCls}-menu-item-multi-check-all`} role="menuitem" onMouseDown={e => e.preventDefault()}>
                <div className={`${prefixCls}-menu-item-content`}>
                    <Checkbox className={`${prefixCls}-menu-item-checkbox`} checked={checked} indeterminate={indeterminate} onChange={onMultiSelectAll}>
                        <span className={`${prefixCls}-menu-item-label`}>{locale === null || locale === void 0 ? void 0 : locale.checkAll}</span>
                    </Checkbox>
                </div>
            </li>);
    }
    getActiveOptions(values) {
        const { options } = this.props;
        const activeValue = values || this.props.activeValue;
        return arrayTreeFilter(options, (o, level) => o[this.getFieldName('value')] === activeValue[level], { childrenKeyName: this.getFieldName('children') });
    }
    getShowOptions() {
        const { options } = this.props;
        const result = this.getActiveOptions()
            .map(activeOption => activeOption[this.getFieldName('children')])
            .filter(activeOption => !isEmpty(activeOption));
        result.unshift(options);
        return result;
    }
    delayOnEvent(onEvent, ...args) {
        if (this.delayTimer) {
            clearTimeout(this.delayTimer);
            this.delayTimer = null;
        }
        if (typeof onEvent === 'function') {
            this.delayTimer = window.setTimeout(() => {
                onEvent(...args);
                this.delayTimer = null;
            }, 150);
        }
    }
    scrollActiveItemToView() {
        var _a;
        // scroll into view
        const showOptions = this.getShowOptions();
        const optionsLength = showOptions.length;
        const activeValue = this.props.activeValue;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < optionsLength; i++) {
            const menuItemParent = this.vMenus[i];
            const options = showOptions[i];
            const index = findIndex(options, option => {
                const value = option[this.getFieldName('value')];
                return value === activeValue[i];
            });
            (_a = menuItemParent === null || menuItemParent === void 0 ? void 0 : menuItemParent.scrollTo) === null || _a === void 0 ? void 0 : _a.call(menuItemParent, { index });
        }
    }
    setMenuPosition(callback = () => { }) {
        var _a, _b, _c, _d, _e, _f;
        const { menusEdgeBuffer, popupPlacement } = this.props;
        const menuDirections = [];
        const optionsLength = this.getShowOptions().length;
        if (Number(optionsLength) <= 0) {
            return;
        }
        const isPlaceTop = ['topLeft', 'topRight'].includes(popupPlacement);
        const clientHeight = window.innerHeight;
        const clientWidth = window.innerWidth;
        for (let i = 1; i < optionsLength; i++) {
            const currentMenu = this.menus[i];
            const prevMenu = this.menus[i - 1];
            const prevVMenu = this.vMenus[i - 1].componentRef.current;
            // 1、计算left并设置
            let prevMenusWidthSum = 0;
            const prevMenuDir = menuDirections[i - 1] || 'right';
            if (prevMenuDir === 'right') {
                // 往右展开时到达边界
                // eslint-disable-next-line max-len
                if (clientWidth - prevMenu.getBoundingClientRect().left - prevMenu.offsetWidth - DEFAULT_MENU_GAP < currentMenu.offsetWidth) {
                    prevMenusWidthSum = prevMenu.offsetLeft - currentMenu.offsetWidth - DEFAULT_MENU_GAP;
                    menuDirections[i] = 'left';
                }
                else {
                    prevMenusWidthSum = prevMenu.offsetLeft + prevMenu.offsetWidth + DEFAULT_MENU_GAP;
                    menuDirections[i] = 'right';
                }
            }
            else if (prevMenuDir === 'left') {
                // 往左展开时到达边界
                if (prevMenu.getBoundingClientRect().left - DEFAULT_MENU_GAP < currentMenu.offsetWidth) {
                    prevMenusWidthSum = prevMenu.offsetLeft + prevMenu.offsetWidth + DEFAULT_MENU_GAP;
                    menuDirections[i] = 'right';
                }
                else {
                    prevMenusWidthSum = prevMenu.offsetLeft - currentMenu.offsetWidth - DEFAULT_MENU_GAP;
                    menuDirections[i] = 'left';
                }
            }
            // 设置left
            currentMenu.style.left = prevMenusWidthSum + 'px';
            // 2、计算top/bottom并设置
            if (isPlaceTop) {
                const prevMenuBottom = Number(getElementStyle(prevMenu).bottom.replace('px', ''));
                const prevMenuTransform = (_b = getElementStyle((_a = this.menuItems[i - 1]) === null || _a === void 0 ? void 0 : _a.parentElement)) === null || _b === void 0 ? void 0 : _b.transform;
                const prevMenuTranslateY = prevMenuTransform && prevMenuTransform !== 'none'
                    ? parseFloat(prevMenuTransform.substring(6).split(',')[5]) : 0;
                const bottom = prevMenu.offsetHeight
                    + prevMenuBottom
                    + (prevVMenu.scrollTop - prevMenuTranslateY)
                    - (((_c = this.menuItems[i - 1]) === null || _c === void 0 ? void 0 : _c.offsetTop) || 0)
                    - currentMenu.offsetHeight;
                currentMenu.style.bottom = (bottom < 0 ? 0 : bottom) + 'px';
            }
            else {
                const prevMenuTop = Number(getElementStyle(prevMenu).top.replace('px', ''));
                const prevMenuTransform = (_e = getElementStyle((_d = this.menuItems[i - 1]) === null || _d === void 0 ? void 0 : _d.parentElement)) === null || _e === void 0 ? void 0 : _e.transform;
                const prevMenuTranslateY = prevMenuTransform && prevMenuTransform !== 'none'
                    ? parseFloat(prevMenuTransform.substring(6).split(',')[5]) : 0;
                const prevMenuItemsTopSum = prevMenuTop
                    + (((_f = this.menuItems[i - 1]) === null || _f === void 0 ? void 0 : _f.offsetTop) || 0)
                    - (prevVMenu.scrollTop - prevMenuTranslateY);
                const menuWrapTop = this.menuWrap.parentElement.getBoundingClientRect().top;
                const currentMenuHeight = currentMenu.offsetHeight;
                const currentMenuMaxTop = clientHeight - menuWrapTop - currentMenuHeight - menusEdgeBuffer;
                const currentMenuTop = (() => {
                    if (currentMenuMaxTop <= 0) {
                        return 0;
                    }
                    return prevMenuItemsTopSum > currentMenuMaxTop ? currentMenuMaxTop : prevMenuItemsTopSum;
                })();
                currentMenu.style.top = (currentMenuTop < 0 ? 0 : currentMenuTop) + 'px';
            }
        }
        if (typeof callback === 'function') {
            callback();
        }
    }
    handleMenuScrollChange(menuScrollOpen) {
        this.setState({ menuScrollOpen });
    }
    render() {
        const { prefixCls, transitionName, visible, virtual, hoveredValue, dropdownMenuRender, dropdownMenuColumnStyle, size, mode } = this.props;
        const showOptions = this.getShowOptions();
        const isMulti = mode === 'multiple';
        const sizeCls = classnames({
            [`${prefixCls}-menu-lg`]: size === 'large',
            [`${prefixCls}-menu-sm`]: size === 'small'
        });
        const menuClas = classnames(`${prefixCls}-menu`, {
            [`${prefixCls}-menu-multi`]: isMulti,
            [sizeCls]: sizeCls
        });
        const menu = showOptions.map((options, menuIndex) => {
            const menuKey = `u + ${menuIndex}`;
            const menuProps = {
                key: menuKey,
                className: menuClas,
                ref: this.saveMenus(menuIndex),
                style: dropdownMenuColumnStyle
            };
            const getMenu = (menuProps) => (<ul {...menuProps}>
                    <List itemKey="value" ref={this.saveVMenus(menuIndex)} data={options} height={256} itemHeight={32} fullHeight={false} virtual={virtual} onMouseDown={e => e.preventDefault()} onScroll={this.handleMenuScroll(menuIndex)}>
                        {(option, optionIndex) => {
                    const optionComp = this.getOption(option, menuIndex);
                    if (optionIndex === 0) {
                        return (<>
                                        {this.getCheckAllOption(menuIndex)}
                                        {optionComp}
                                    </>);
                    }
                    return optionComp;
                }}
                    </List>
                </ul>);
            if (dropdownMenuRender) {
                return (<div {...menuProps}>
                        {dropdownMenuRender(getMenu(), menuIndex, hoveredValue)}
                    </div>);
            }
            return getMenu(menuProps);
        });
        return (<CSSMotion visible={visible} motionName={transitionName} removeOnLeave={false} leavedClassName={`${prefixCls}-menu-wrap-hidden`} onAppearActive={this.onShowActive} onEnterActive={this.onShowActive} onLeaveEnd={this.onShowEnd}>
                {({ className, style }) => {
                return (<div ref={this.saveMenuWrap} className={className} style={Object.assign({ position: 'relative' }, style)}>
                            {menu}
                        </div>);
            }}
            </CSSMotion>);
    }
}
Menus.defaultProps = {
    options: [],
    value: [],
    activeValue: [],
    onSelect() { },
    prefixCls: 'rc-cascader-menus',
    visible: false,
    virtual: false,
    expandTrigger: 'click',
    menusEdgeBuffer: 20
};
export default Menus;
